import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';

const BSLANWILayer = async () => {
    type layerModules = [typeof import('esri/layers/MapImageLayer')];

    const [MapImageLayer] = await (loadModules(['esri/layers/MapImageLayer']) as Promise<layerModules>);

    return new MapImageLayer({
        title: 'National Wetlands Inventory',
        url: 'https://www.fws.gov/wetlandsmapservice/rest/services/Wetlands/MapServer',
        visible: false,
        opacity: 0.75,
        minScale: 150000,
        listMode: 'hide-children',
        sublayers: [
            {
                id: 0,
                popupTemplate: {
                    outFields: ['*'],
                    title: 'National Wetlands Inventory',
                    content: (feature: __esri.Feature) => {
                        const atts = feature.graphic.attributes;
                        const node = document.createElement('div');

                        const content = (
                            <React.Fragment>
                                <BSLAPopupItemComponent label="Wetland Type" value={atts['NWI_Wetland_Codes.SYSTEM_NAME']} />
                                <p className="mt-3 mb-1">
                                    Issue: Most wetlands are highly regulated by federal, state, and local agencies. Permits are required to impact regulated wetland habitat.
                                </p>
                                <p>
                                    Cost: After wetland impacts to regulated wetlands are justified, mitigation to offset the impact such as creating new wetlands or purchasing
                                    mitigation credits is required at a cost ranging from $50,000-$200,000 per acre (not including permitting costs) depending on habitat quality
                                    and type.
                                </p>
                            </React.Fragment>
                        );

                        ReactDOM.render(content, node);

                        return node;
                    },
                },
            },
        ],
    });
};

export default BSLANWILayer;
